import { getConfigInfo } from '@/utils'
const item = getConfigInfo()
const subName = item ? item.subName : '系统'

export const ultimate = {
  organizationStatus: [{
    value: 2,
    label: '启用'
  }, {
    value: 3,
    label: '已过期'
  }, {
    value: 8,
    label: '禁用'
  }],
  ultimateSystemVersion: [{
    value: 22,
    label: '标准版'
  }, {
    value: 3,
    label: '专业版'
  }, {
    value: 4,
    label: '企业版'
  }],
  groupSystemVersion: [{
    value: 21,
    label: '车商版'
  }, {
    value: 22,
    label: '基础版'
  }, {
    value: 3,
    label: '专业版'
  }],
  // 日期类型
  performanceDateStatus: [{
    value: 1,
    label: '年度业绩'
  }, {
    value: 2,
    label: '季度业绩'
  }, {
    value: 3,
    label: '月度业绩'
  }, {
    value: 4,
    label: '自定义时间段业绩'
  }],
  performanceDateType: [{
    value: 8,
    label: '支付日期'
  }, {
    value: 1,
    label: '签单日期'
  }, {
    value: 12,
    label: '核保日期'
  }, {
    value: 4,
    label: '保单起止日期'
  }, {
    value: 2,
    label: '保单起保日期'
  }, {
    value: 3,
    label: '保单到期日期'
  }, {
    value: 10,
    label: `录入${subName}日期`
  }],
  performanceDateTypeNew: [{
    value: 1,
    label: '签单日期'
  }, {
    value: 12,
    label: '回执日期'
  }, {
    value: 2,
    label: '起保日期'
  }, {
    value: 10,
    label: '录入日期'
  }],
  // 保单类型
  policyTypeList: [{
    label: '不限', value: 0
  }, {
    label: '批单', value: 1
  }, {
    label: '保单', value: 2
  }],
  quarter: [{
    value: 1,
    label: '一季度'
  }, {
    value: 2,
    label: '二季度'
  }, {
    value: 3,
    label: '三季度'
  }, {
    value: 4,
    label: '四季度'
  }],
  dataTypeList: [{
    label: '总单量', value: 'insNum'
  }, {
    label: '商业险单量', value: 'businessNum'
  }, {
    label: '交强险单量', value: 'slipNum'
  }, {
    label: '总保费', value: 'totalPrice'
  }, {
    label: '商业险保费', value: 'businessTotalPrice'
  }, {
    label: '交强险保费', value: 'slipTotalPrice'
  }, {
    label: '车船税', value: 'totalVVTax'
  }, {
    label: '净保费', value: 'sumNetPremium'
  }, {
    label: '商业险净保费', value: 'businessSumNetPremium'
  }, {
    label: '交强险净保费', value: 'slipSumNetPremium'
  }, {
    label: '收入', value: 'totalSettlePrice'
  }, {
    label: '支出', value: 'salesmanTotalSettlePrice'
  }, {
    label: '利润', value: 'totalProfit'
  }],
  insData: [{
    label: '单量', value: 'insNum'
  }, {
    label: '单量占比', value: 'countProportion'
  }, {
    label: '净保费', value: 'netPremium'
  }, {
    label: '总保费', value: 'totalPrice'
  }, {
    label: '保费占比', value: 'priceProportion'
  }],
  insList: [{
    label: '车损', value: '10001'
  }, {
    label: '三者', value: '10002'
  }, {
    label: '盗抢', value: '30003'
  }, {
    label: '人员(司机)', value: '30004'
  }, {
    label: '人员(乘客)', value: '30005'
  }, {
    label: '第三方特约险', value: 'thirdIns'
  }, {
    label: '不计免赔', value: 'noDeductible'
  }, {
    label: '其它险别', value: 'otherInsType'
  }],
  timeQuantum: [{
    label: '今日', value: 0
  }, {
    label: '年度', value: 1
  }, {
    label: '季度', value: 2
  }, {
    label: '月度', value: 3
  }, {
    label: '自定义', value: 4
  }],
  regulationDateType: [
    {
      label: '开票日期',
      value: 99
    },
    {
      label: '签单日期',
      value: 1
    }
  ],
  sumPremiumType: [
    {
      label: '总保费',
      value: 1
    },
    {
      label: '净保费',
      value: 2
    }
  ]
}

export default {
  ultimate
}



// WEBPACK FOOTER //
// ./src/data/ultimate.js